import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";
import { TrimPipe } from 'angular-pipes/src/string/trim.pipe';

@Directive({ selector: "[trim]" })
export class TrimDirective  {

    private el: HTMLInputElement;
    private trimPipe: TrimPipe;

    constructor(
        private elementRef: ElementRef

    ) {
        this.el = this.elementRef.nativeElement;
        this.trimPipe = new TrimPipe();
    }


    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        
        this.el.value = this.trimPipe.transform(value);
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/trim.directive.ts